export const SIMULATE = "SIMULATE";
export const SIMULATE_SUCCESS = "SIMULATE_SUCCESS";
export const SIMULATE_FAILURE = "SIMULATE_FAILURE";
export const CLEAR_SIMULATOR = "CLEAR_SIMULATOR";



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/premiumSimulator/premiumSimulatorTypes.js